import React from "react";
import { Col, Row, Card, CardBody } from "reactstrap";
import {
  currencyFormatWithoutDecimalV1,
  getPercentageWithAlertV1,
} from "../../helpers/api_helper";
import Loader from "../../Components/Common/Loader";

const MenuOptimizationWidgets = ({
  foodRevenue,
  beverageRevenue,
  foodCostPercent,
  bevCostPercent,
  foodToBeverageRatio,
  currency,
  menuOptWidgetsAjax,
}) => {
  const widgets = [
    {
      id: 1,
      label: "Food Revenue",
      counter: !menuOptWidgetsAjax
        ? `${currencyFormatWithoutDecimalV1(foodRevenue, currency)}`
        : "",
    },
    {
      id: 2,
      label: "Beverage Revenue",
      counter: !menuOptWidgetsAjax
        ? `${currencyFormatWithoutDecimalV1(beverageRevenue, currency)}`
        : "",
    },
    {
      id: 3,
      label: "Food Cost %",
      counter: !menuOptWidgetsAjax
        ? `${Number(foodCostPercent).toFixed(2)}%`
        : "",
    },
    {
      id: 4,
      label: "Bev Cost %",
      counter: !menuOptWidgetsAjax
        ? `${Number(bevCostPercent).toFixed(2)}%`
        : "",
    },
    {
      id: 5,
      label: "Food to Bev Ratio",
      counter: !menuOptWidgetsAjax ? foodToBeverageRatio : "",
    },
  ];

  return (
    <Row id="MenuOptimizationWidgets" className="row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-xl-5 g-3">
      {widgets.map((item, key) => (
        <Col key={key}>
          <Card className="card-animate">
            <CardBody>
              {/* {menuOptWidgetsAjax && <Loader />} */}
              <div className="d-flex align-items-center">
                <div className="flex-grow-1 overflow-hidden">
                  <p className="fw-medium text-muted text-truncate mb-3">
                    {item.label}
                  </p>
                  <div className="d-flex align-items-center mb-3">
                    <h4 className="fs-4 flex-grow-1 mb-0">
                      <span className="counter-value me-1">{item.counter}</span>
                    </h4>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default MenuOptimizationWidgets;
